import { useState } from 'react';

import { Button, ButtonsGrid } from 'components/common/button/button';

import AmountWithMax from 'components/common/form/amount-with-max/amount-with-max';
import Disclaimer from 'components/common/form/disclaimer/disclaimer';
import Tooltip from 'components/common/tooltip/tooltip';
import InfoIcon from 'components/icons/InfoIcon';

import {
  StyledContainer,
  StyledSection,
  StyledTitle,
  StyledSubTitle,
  StyledAmount,
  StyledAmountWrapper,
  StyledFlex,
  StyledTotal,
  StyledTotalText,
  StyledTotalValue
} from './views.style';

const DelegateView = ({ closeModal }: { closeModal: () => void }) => {
  const [disabled, setDisabled] = useState(true);

  const onClickHandler = () => {
    closeModal();
  };

  return (
    <StyledContainer>
      <StyledSection p="48px 65px">
        <StyledTitle>Delegate OPN</StyledTitle>
        <StyledSubTitle>
          Delegate your OPN tokens yield OPN and OCC rewards
        </StyledSubTitle>
        <StyledAmountWrapper mb={2}>
          <AmountWithMax />
        </StyledAmountWrapper>
        <StyledFlex>
          <h4>
            Your OPN Reward
            <Tooltip
              isMultiline
              message="An OCC represents one <br /> metric ton of carbon"
            >
              <InfoIcon color="#d5d9e7" />
            </Tooltip>
          </h4>
          <StyledAmount>0.00</StyledAmount>
        </StyledFlex>
        <Disclaimer onChange={(toggle) => setDisabled(toggle)} />
        <StyledTotal>
          <StyledTotalText>Total deposit:</StyledTotalText>
          <StyledTotalValue>0.00 OPN</StyledTotalValue>
        </StyledTotal>
        <ButtonsGrid>
          <Button
            size="big"
            fullwidth
            disabled={disabled}
            onClick={onClickHandler}
          >
            Delegate OPN
          </Button>
        </ButtonsGrid>
      </StyledSection>
    </StyledContainer>
  );
};

export default DelegateView;
